export default __webpack_public_path__ + "static/media/ICSI.ab49070d.webp";